import { Typography } from "antd"

import Accordion from "#blocks/Accordion"
import Flex from "#blocks/Flex"

import AntdAlerts from "./AntdAlerts"
import AntdBasics from "./AntdBasics"
import AntdForms from "./AntdForms"
import AntdLayout from "./AntdLayout"
import AntdMenus from "./AntdMenus"

const AntdThemeTest = () => {
  return (
    <Flex
      col
      gap={20}
      style={{
        padding: "0 20px 40px",
        width: "100vw",
        height: "calc(100vh - 200px)",
        overflow: "auto",
      }}
    >
      <Typography.Title level={4}>Antd Theme Test</Typography.Title>

      <Accordion trigger="Antd Basics">
        <Flex gap={160}>
          <AntdBasics />

          <AntdForms />

          <AntdAlerts />
        </Flex>
      </Accordion>

      <Accordion trigger="Antd Layout">
        <Flex gap={160}>
          <AntdLayout />

          <AntdMenus />
        </Flex>
      </Accordion>
    </Flex>
  )
}

export default AntdThemeTest
